import axios from 'axios';
import router from '@/router';

import auth from '@/utils/auth';

import {
  DELETE_FAQ,
  DELETE_FAQ_ERROR,
  DELETE_FAQ_SUCCESS,

  GET_FAQ,
  GET_FAQ_ERROR,
  GET_FAQ_SUCCESS,

  GET_FAQS,
  GET_FAQS_ERROR,
  GET_FAQS_SUCCESS,

  SAVE_FAQ,
  SAVE_FAQ_ERROR,
  SAVE_FAQ_SUCCESS,

} from './constants';

export default {
  async [DELETE_FAQ]({ commit }, faqQuestionID) {
    try {
      commit(DELETE_FAQ);
      const response = await axios({
        url: `${process.env.API_URL}/api/faqs-questions/${faqQuestionID}`,
        method: 'DELETE',
        headers: auth.getAuthHeader(),
      });
      commit(DELETE_FAQ_SUCCESS, response.data);
    } catch (err) {
      commit(DELETE_FAQ_ERROR, err);
    }
  },

  async [GET_FAQ]({ commit }, faqsID) {
    try {
      commit(GET_FAQ);
      const response = await axios({
        url: `${process.env.API_URL}/api/faqs-questions/${faqsID}`,
        method: 'GET',
        headers: auth.getAuthHeader(),
      });
      commit(GET_FAQ_SUCCESS, response.data);
    } catch (err) {
      commit(GET_FAQ_ERROR, err);
    }
  },

  async [GET_FAQS]({ commit }, args) {
    try {
      commit(GET_FAQS);
      const response = await axios({
        url: `${process.env.API_URL}/api/syndicates/${args.syndicateID}/faqs-questions`,
        method: 'GET',
        headers: auth.getAuthHeader(),
        params: {
          filters: args.filters || null,
        },
      });
      commit(GET_FAQS_SUCCESS, response.data);
    } catch (err) {
      commit(GET_FAQS_ERROR, err);
    }
  },

  async [SAVE_FAQ]({ commit }, data) {
    try {
      commit(SAVE_FAQ);
      let url = `${process.env.API_URL}/api/faqs-questions`;
      let method = 'POST';
      if (data.faqQuestionID) {
        url = `${url}/${data.faqQuestionID}`;
        method = 'PUT';
      }
      const response = await axios({
        url,
        method,
        headers: auth.getAuthHeader(),
        data,
      });
      commit(SAVE_FAQ_SUCCESS, response.data);
      if (method === 'POST' && response.data.syndicateID) {
        router.push({ name: 'Information FAQ Listing', params: { syndicateID: response.data.syndicateID } });
      }
    } catch (err) {
      commit(SAVE_FAQ_ERROR, err);
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Information/FAQs/actions.js